import { cn } from '@shared/utils';
import { TravelRequest, TravelTeam } from './widgets';

export const TravelNewRequestPage = () => {
  return (
    <section className={cn('flex gap-6', 'max-xl:flex-col')}>
      <TravelRequest className='flex-1' />
      <TravelTeam className={cn('basis-1/3', 'max-xl:basis-auto')} />
    </section>
  );
};
